
import { createReducer, on } from '@ngrx/store';
import { loadForm, saveForm, updateForm } from './formEntreprise.actions';

export interface FormState {
    formEntreprise:{
        data:{}
    }
}

export const initialFormState: FormState = {
    formEntreprise:{
        data:{}
    }
};

export const formEntrepriseReducer = createReducer(
    initialFormState,

    on(loadForm, (state) => ({ ...state, loading: true })),

    on(saveForm, (state) => ({ ...state, loading: true })),

    on(updateForm, (state, data) => ({
        ...state,
        data
    }))
);